import { render } from "./TermsModal.vue?vue&type=template&id=6c8bcec6&scoped=true&ts=true"
import script from "./TermsModal.vue?vue&type=script&lang=ts"
export * from "./TermsModal.vue?vue&type=script&lang=ts"

import "./TermsModal.vue?vue&type=style&index=0&id=6c8bcec6&scoped=true&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8bcec6"]])

export default __exports__